import { all, fork, call, put, select, takeEvery, getContext, take } from 'redux-saga/effects';

import { getProgrammableTags, getAppliedTagsNum } from '../../api/api';
import { logout } from '../auth/actions';
import { getPathwayAndUni } from '../selectors';
import { programmableTagsActions } from './reducer';
import { ConfigActionTypes } from '../config/types';

function* handleGetProgrammableTags() {
  yield call(handleGetProgrammableTags2);
}

function* handleGetProgrammableTags2() {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);

    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetProgrammableTags2');
      return;
    }
    // Check if uni config is already loaded
    const dataState = yield select((state: any) => state.data);

    // Only wait for config action if it hasn't been loaded yet
    if (!dataState.isConfigLoaded) {
      const res = yield take([ConfigActionTypes.GET_UNI_CONFIG_SUCCESS, ConfigActionTypes.GET_UNI_CONFIG_FAILURE]);
      if (res.type === ConfigActionTypes.GET_UNI_CONFIG_FAILURE) {
        throw new Error('Uni config call failed, cannot retrieve the required params for call.');
      }
    }
    const { pathway, uni } = yield select(getPathwayAndUni);
    // First arg is owner: pathway (provider) if exists, else uni
    const programmableTags = yield call(getProgrammableTags, idToken, pathway || uni, pathway ? uni : undefined);

    yield put(programmableTagsActions.getProgrammableTagRecordsSuccess(programmableTags));
  } catch (err) {
    if (err instanceof Error) {
      yield put(programmableTagsActions.getProgrammableTagRecordsFailure(err.message!));
    } else {
      yield put(programmableTagsActions.getProgrammableTagRecordsFailure('An unknown error occurred.'));
    }
  }
}

function* handleGetAppliedTagsNum(action: ReturnType<typeof programmableTagsActions.getAppliedTagsNum>): any {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAppliedTagsNum');
      return;
    }
    // Check if uni config is already loaded
    const dataState = yield select((state: any) => state.data);

    // Only wait for config action if it hasn't been loaded yet
    if (!dataState.isConfigLoaded) {
      const res = yield take([ConfigActionTypes.GET_UNI_CONFIG_SUCCESS, ConfigActionTypes.GET_UNI_CONFIG_FAILURE]);
      if (res.type === ConfigActionTypes.GET_UNI_CONFIG_FAILURE) {
        throw new Error('Uni config call failed, cannot retrieve the required params for call.');
      }
    }
    const { pathway, uni } = yield select(getPathwayAndUni);
    const programmableTag = action.payload;
    // First arg is owner: pathway (provider) if exists, else uni
    const tagsNum = yield call(getAppliedTagsNum, idToken, pathway || uni, programmableTag, pathway ? uni : undefined);

    yield put(programmableTagsActions.getAppliedTagsNumSuccess({ applied: tagsNum.applied, removed: tagsNum.removed }));
  } catch (err) {
    if (err instanceof Error) {
      yield put(programmableTagsActions.getAppliedTagsNumFailure(err.message!));
    } else {
      yield put(programmableTagsActions.getAppliedTagsNumFailure('An unknown error occurred.'));
    }
  }
}

function* watchProgrammableTags() {
  yield takeEvery(programmableTagsActions.getProgrammableTagRecords.type, handleGetProgrammableTags);
  yield takeEvery(programmableTagsActions.getAppliedTagsNum.type, handleGetAppliedTagsNum);
}

function* ProgrammableTagSaga() {
  yield all([fork(watchProgrammableTags)]);
}

export default ProgrammableTagSaga;
